import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeSlug from 'rehype-slug';

export default function PrivacyPolicyPage() {
  const [policy, setPolicy] = useState('');
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    fetch('/privacy.md', { signal: controller.signal })
      .then(response => {
        if (!response.ok) throw new Error(`Privacy request failed: ${response.status}`);
        return response.text();
      })
      .then(setPolicy)
      .catch(error => {
        if (error instanceof DOMException && error.name === 'AbortError') return;
        setLoadFailed(true);
      });

    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (!policy || !window.location.hash) return;
    const id = window.location.hash.slice(1);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }, [policy]);

  return (
    <div className="min-h-screen bg-dark-canvas text-gray-300 py-16 px-4">
      <article className="max-w-3xl mx-auto prose prose-invert
        prose-headings:text-white prose-headings:font-semibold
        prose-h1:text-3xl prose-h1:mb-2
        prose-h2:text-xl prose-h2:mt-10 prose-h2:mb-3
        prose-h3:text-lg prose-h3:mt-6 prose-h3:mb-2
        prose-p:text-gray-300 prose-p:leading-relaxed
        prose-strong:text-white
        prose-a:text-violet-400 prose-a:no-underline hover:prose-a:underline
        prose-ul:text-gray-300 prose-li:my-1
        prose-table:text-sm prose-th:text-white prose-td:text-gray-300
        prose-hr:border-dark-border">
        {policy && <ReactMarkdown rehypePlugins={[rehypeSlug]}>{policy}</ReactMarkdown>}

        {!policy && !loadFailed && (
          <p className="text-gray-400">Loading Privacy Policy…</p>
        )}

        {loadFailed && (
          <div>
            <h1>Privacy Policy</h1>
            <p>
              The Privacy Policy could not be loaded. Please try again or contact{' '}
              <a href="mailto:support@coachsightecr.com">support@coachsightecr.com</a>.
            </p>
          </div>
        )}
      </article>
    </div>
  );
}
